import {EventEmitter, InjectionToken, Type} from '@angular/core';
import {
    SearchFilterDefinition,
    SearchFilterSelection,
    SearchFilterValue,
} from '../filter-state.models';

export interface SearchFilterBarComponentContract {
    definitions: readonly SearchFilterDefinition<SearchFilterValue>[];
    initialSelection: SearchFilterSelection<SearchFilterValue>;
    selectionChange: EventEmitter<SearchFilterSelection<SearchFilterValue>>;
}

export const LESSONS_SEARCH_FILTER_BAR_COMPONENT = new InjectionToken<Type<SearchFilterBarComponentContract>>(
    'LESSONS_SEARCH_FILTER_BAR_COMPONENT'
);

export interface SearchFilterQueryAdapter {
    readonly urlParamKeys: readonly string[];
    toQueryFilters(selection: SearchFilterSelection<SearchFilterValue>): Record<string, SearchFilterValue>;
    toUrlParams(selection: SearchFilterSelection<SearchFilterValue>): Record<string, SearchFilterValue>;
}

export const LESSONS_SEARCH_FILTER_QUERY_ADAPTER = new InjectionToken<SearchFilterQueryAdapter>(
    'LESSONS_SEARCH_FILTER_QUERY_ADAPTER'
);
